import {UNREAD, IGNORE} from '@/views/Message/config';
export default {
    namespaced: true,
    state: {
        systemMessages: [], // 所有未读系统消息，浮窗仅展示未读
        personalMessages: [], // 所有未读个人消息，浮窗仅展示未读
        refreshUserCenterMessage: '', // 刷新用户中心消息,
        systemMessageCount: 0, // 系统消息未读+忽略数
        personalMessageCount: 0 // 个人消息未读+忽略数
    },
    mutations: {
        SET_SYSTEM_MESSAGES: (state, val) => {
            state.systemMessages = val;
        },
        SET_PERSONAL_MESSAGES: (state, val) => {
           state.personalMessages = val;
        },
        SET_REFRESH_USER_CENTER_MESSAGE: (state, val) => {
            state.refreshUserCenterMessage = val;
        },
        SET_SYSTEM_MESSAGE_COUNT: (state, val) => {
            state.systemMessageCount = val;
        },
        SET_PERSONAL_MESSAGE_COUNT: (state, val) => {
            state.personalMessageCount = val;
        }
    },
    actions: {
        // 获取未读消息
        async getMessages({commit}, {model, type}) {
            try {
                const typeValue = type === 'system' ? 1 : 0;
                const params = {
                    filters: [
                        {field: 'messageType', op: 'eq', values: [typeValue]},
                        {field: 'status', op: 'eq', values: [UNREAD]}
                    ]
                };
                const res = await model.message.getMessageList(params);
                if (type === 'system') {
                    commit('SET_SYSTEM_MESSAGES', res?.listData || []);
                }
                else {
                    commit('SET_PERSONAL_MESSAGES', res?.listData || []);
                }
                return res;
            }
            catch (err) {
                return Promise.reject(err);
            }
        },
        async getCount({commit}, {model, type}) {
            const typeValue = type === 'system' ? 1 : 0;
            // 未读+忽略的消息数
            let params = {
                filters: [
                    {field: 'messageType', op: 'eq', values: [typeValue]},
                    {field: 'status', op: 'in', values: [UNREAD, IGNORE]}
                ]
            };
            const data = await model.message.getMessageList(params);
            const count = data.totalCount;
            if (type === 'system') {
                commit('SET_SYSTEM_MESSAGE_COUNT', count);
            }
            else {
                commit('SET_PERSONAL_MESSAGE_COUNT', count);
            }
        }
    }
};